import React from 'react'
import SideBar from './components/layout/SideBar/SideBar'

function Layout() {
    return (
        <div>
            <SideBar />
        </div>
    )
}

export default Layout